module.exports = __webpack_public_path__ + "img/btnCard-5-m.c97c44fe.jpg";